import TextArea from "../../components/TextArea";

export const CourseTextArea = TextArea;
